import { Component, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'app-help',
    template: require('./apphelp.component.html'),
    styles: [require('./apphelp.component.css')]
})

export class AppHelpComponent{
    @Output() displayStatus = new EventEmitter<boolean>();

    helpSlowRunningScript:string = "./images/slow_running_script.png";
    mainWindowImg:string = "./images/AppMainViewSS.PNG";
    searchPlansImg:string = "./images/SearchPlansSS.PNG";
    generateParcelReportImg:string = "./images/GenerateParcelReportSS.PNG";
    legendCollapsedImg:string = "./images/LegendCollapsed_SS.PNG";
    legendExpandedImg:string = "./images/LegendExpaned_SS.PNG";
    showModulesButtonImg:string = "./images/ShowModulesButton_SS.PNG";
    addressComponentImg:string = "./images/AddressComponent_SS.PNG";
    extraToolsImg:string = "./images/ExtraTools_SS.PNG";
    identifyToolImg:string = "./images/IdentifyTool_SS.PNG";
    identifyParcelPRCImg:string = "./images/IdentifyParcelPRC_SS.PNG";
    identifyParcelReportImg:string = "./images/IdentifyParcelReport_SS.PNG";

    constructor(){
        
    }

    ngOnInit() {
    }

    closePanel() {
        this.displayStatus.emit(false);
    }
}


// WEBPACK FOOTER //
// ./app/tools/apphelp.component.ts